/**
 *
 * @param defaultRegion
 * @param contractKrn
 * `contractKrn` example: `krn:bpcs-eu:contract-onboarding:de1bae10-afc9-4e44-9396-fd53f994472e`
 */
export const getContractOnboardingRegionFromKrn = (defaultRegion, contractKrn) => {
    if (!contractKrn) {
        return defaultRegion;
    }
    const [_, bpcsRegion] = contractKrn.split(':');
    if (!bpcsRegion) {
        return defaultRegion;
    }
    const region = bpcsRegion.split('-')[1];
    const hasValidRegion = ['eu', 'us', 'ap'].includes(region);
    return hasValidRegion ? region : defaultRegion;
};
